import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Col } from 'antd';
import HeaderBack from '../../../components/mobile/speak-doctor/HeaderBack';
import SubmitResponseForm from '../../../components/mobile/speak-doctor/SubmitResponseForm';

function MobileSubmitResponseScreen() {
  const { t } = useTranslation(['speak-doctor', 'common']);
  const history = useHistory();

  const onConfirm = () => {
    history.push('/sign-up/guest/thank-you')
  }

  return (
    <>
      <HeaderBack
        previousPage='/speak-doctor'
        text={t('speak-doctor:submitRequest.previousPage')}
        title={t('speak-doctor:submitRequest.title')}
        subtitle={t('speak-doctor:submitRequest.subtitle')}
      />
      <Col xs={24}>
        <SubmitResponseForm
          onSubmitForm={onConfirm}
          onSubmitBtnText={t('common:button.submitRequest')}
        />
      </Col>
    </>
  );
}

export default MobileSubmitResponseScreen;
